<!-- TEMPLATE -->
<template>
    <div :class='agreementsListClass'>
        <div class='row'>
            <div class='small-12 medium-12 large-12 hd-12 columns dashboard-content'>
                <dean-section-title content='true'>
                  <span slot='title'>
                    <span class='avenir-heavy'>{{title}}</span>
                  </span>

                  <dean-section-title-item
                    v-if="canCreatePartnerAgreement()"
                    :icon='plusIcon'
                    :content="true"
                    @click.native="sectionRoute('partners.agreements.add', {contextId: $route.params.pid})"
                  >
                    Nieuw
                  </dean-section-title-item>
                </dean-section-title>

                <dean-table
                        :data='agreementsData'
                        :columns='columns'
                        :hover="true"
                        @column-click='columnClick'
                        @cell-click="cellClick"
                >
                </dean-table>

                <dean-pagination
                        :current-page='agreementsMetaData.pageNumber'
                        :total-items='agreementsMetaData.totalResults'
                        :items-per-page='agreementsMetaData.itemsPerPage'
                        :select-items-per-page='selectItemsPerPage'
                        :visible-pages='agreementsMetaData.visiblePages'
                        @page-changed='paginationChanged'
                        @items-per-page='itemsPerPageChanged'
                >
                </dean-pagination>
            </div>
        </div>
    </div>
</template>

<script lang='ts'>
  // VUE
  import {
    Vue,
    Component,
  } from 'vue-property-decorator';
  import axios from 'axios';
  import deanTableMixin, {Meta} from '@/mixins/deanTableMixin';
  import sideMenuPartnerMixin from '@/mixins/sideMenuPartnerMixin';
  import {mixins} from 'vue-class-component';
  import {getDutchDateFormat} from '@/mixins/dateWrapper';

  import {
    // SVG
    invoicesIcon,
    archiveIcon,
    returnIcon,
    // COMPONENTS
    deanTable,
    deanPagination,
    deanInputSelect,
    deanSectionDivider,
    deanSectionTitle,
    deanSectionTitleItem,
    deanSearchField,
    deanIcon,
    plusIcon,
    summeryIcon,
  } from '@deanone/dean-components';

  @Component({
    components: {
      deanPagination,
      deanTable,
      deanInputSelect,
      deanSectionDivider,
      deanSectionTitle,
      deanSectionTitleItem,
      deanSearchField,
      invoicesIcon,
      deanIcon,
      plusIcon,
      summeryIcon,
    },
  })
  export default class List extends mixins(deanTableMixin, sideMenuPartnerMixin) {

    public showSomething: boolean = false;
    public plusIcon: object = plusIcon;
    public archiveIcon: object = archiveIcon;
    public returnIcon: object = returnIcon;
    public data: object[] = [];
    public showArchive: boolean = false;

    // COMPUTED
    get agreementsListClass() {
      let value = 'address-summary';
      if (this.showSomething) {
        value += ' no-scroll-container';
      }
      return value;
    }

    get agreementsMetaData() {
      return this.pageMeta;
    }

    get agreementsData() {
      return this.data;
    }

    get title() {
      return this.showArchive ? 'Verwijderde overeenkomsten' : 'Overeenkomsten';
    }

    public columns: any = {
      description: {
        content: 'Beschrijving',
        align: 'left',
        sort: true,
        dql: 'description',
      },
      type: {
        content: 'Type',
        align: 'left',
        sort: true,
        dql: 'type',
      },
      manager: {
        content: 'Manager',
        align: 'left',
        sort: true,
        dql: 'manager',
      },
      commissionGate: {
        content: 'Staffel',
        align: 'left',
        sort: true,
        dql: 'gate',
      },
      startDate: {
        content: 'Startdatum',
        align: 'left',
        sort: true,
        dql: 'startDate',
      },
      endDate: {
        content: 'Einddatum',
        align: 'left',
        sort: true,
        dql: 'endDate',
      },
    };

    public tableName(): string {
      return 'partner-agreements';
    }

    public cellClick(target: { cell: object, row: { id: string, contextId: string }, column: string }) {
      this.$router.push({
        name: 'partners.agreements.edit',
        params: {paid: target.row.id},
      });
    }

    // METHODS
    public loadList(data: any) {
      this.$store.dispatch('setLoadOverlay', true);

      const url = '/-/trade/api/partner.agreements.list';

      axios.post(url, {
        id: this.$route.params.pid,
        meta: this.pageMeta,
        activeOnly: false,
      })
        .then((response) => {
          const partnerAgreementsData: any[] = [];
          for (const item of response.data.data) {
            const row = {
              id: item.id,
              description: item.description,
              type: item.typeName,
              manager: item.partnerManagerName,
              commissionGate: item.commissionGateName,
              startDate: getDutchDateFormat(item.startDate),
              endDate: getDutchDateFormat(item.endDate),
            };
            partnerAgreementsData.push(row);
          }

          this.data = partnerAgreementsData;
          this.pageMeta = response.data.meta;
        },
        ).finally(
          () => {
            this.$store.dispatch('setLoadOverlay', false);
          },
      );
    }

    public canCreatePartnerAgreement(): boolean {
      if (this.$store.getters.getUser.privileges.includes('create-partner-agreement')) {
        return true;
      }

      return false;
    }

    public created() {
      this.setDefaultSort('startDate');
      this.loadList(this.pageMeta);
      this.buildSideMenuPartner();
    }
  }
</script>

<!-- STYLE -->

<style lang='scss' scoped>
    @import '~@deanone/dean-components/src/scss/vars';
</style>

